import { Box, Brand, Img, LogoAt, Page, Text } from "../primitives";
/** Reference page 38 — «نضيف أفكارا وليس لوحات...». Fully fixed. */
export function ClosingPage() {
    return (<Page>
      <Box x={0} y={0} w={1125} h={603.1} style={{ overflow: "hidden" }}>
        <Img src="/proposal-assets/template/closing-collage.jpg" x={0} y={-103.5} w={1138.5} h={805.2} opacity={0.96}/>
      </Box>
      <Box x={0} y={603.1} w={1125} h={206.9} style={{ background: "#000000" }}/>
      <LogoAt cx={73.25} cy={105.35} w={31.2} color="#ffffff"/>
      <Brand right={1063} top={76} size={33} color="#ffffff"/>
      <Text right={1051} top={646} size={42} weight={700} color="#ffffff">
        نضيف أفكارا وليس
      </Text>
      <Text right={1051} top={710} size={42} weight={700} color="#ffffff">
        لوحات...
      </Text>
    </Page>);
}
